import { render, staticRenderFns } from "./game-type.vue?vue&type=template&id=7ca2bd07&"
import script from "./game-type.vue?vue&type=script&lang=js&"
export * from "./game-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports